module.exports = __webpack_public_path__ + "img/Weapon_19.47202545.png";